// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__4QAMF","title":"InfoRow_title__1J8ru"};